(() => {
  'use strict';
  const configNode = document.getElementById('ld-savings-config');
  const pricing = window.LiftDownSavings;
  if (!configNode || !pricing || customElements.get('ld-tiered-savings')) return;
  const config = JSON.parse(configNode.textContent);
  if (!config.enabled) return;
  let cartCount = pricing.quantity(config.count);
  const components = new Set();
  function node(tag, className, text) {
    const element = document.createElement(tag);
    element.className = className;
    if (text !== undefined) element.textContent = text;
    return element;
  }
  class TieredSavings extends HTMLElement {
    connectedCallback() {
      components.add(this);
      if (!this.querySelector('.ld-savings__heading')) {
        this.classList.add('ld-savings');
        const heading = node('p', 'ld-savings__heading', config.heading);
        if (this.dataset.context === 'cart') {
          const summary = node('div', 'ld-savings__summary');
          const count = node('span', 'ld-savings__count');
          count.dataset.savingsCount = '';
          count.setAttribute('aria-hidden', 'true');
          summary.append(heading, count);
          const meter = node('progress', 'ld-savings__meter');
          meter.dataset.savingsMeter = '';
          meter.max = 4;
          meter.value = 0;
          meter.setAttribute('aria-label', config.heading);
          const milestones = node('div', 'ld-savings__milestones');
          for (const [quantity, modifier, label] of [[2, 'shipping', config.shippingMilestone], [4, 'free', config.freeOne]]) {
            const milestone = node('span', `ld-savings__milestone ld-savings__milestone--${modifier}`);
            milestone.dataset.savingsMilestone = quantity;
            milestone.append(node('span', 'ld-savings__milestone-count', config.items.replace('[count]', quantity)), node('span', '', label));
            milestones.append(milestone);
          }
          this.append(summary, meter, milestones);
        } else {
          this.append(heading, node('p', 'ld-savings__detail', config.detail));
        }
        const progress = node('p', 'ld-savings__progress');
        progress.dataset.savingsProgress = '';
        progress.setAttribute('role', 'status');
        progress.setAttribute('aria-live', 'polite');
        progress.setAttribute('aria-atomic', 'true');
        this.append(progress);
      }
      this.update(cartCount);
    }
    disconnectedCallback() { components.delete(this); }
    update(count) {
      const progress = this.querySelector('[data-savings-progress]');
      const offer = pricing.cartProgress(count);
      const nextReward = pricing.label(offer.target, config);
      const next = (config.nextReward || 'Add [count] more to unlock [reward].')
        .replace('[count]', offer.remaining).replace('[reward]', nextReward);
      const earned = offer.free ? config.unlocked.replace('[reward]', pricing.label(count, config)) + ' ' : '';
      const message = this.dataset.context === 'cart' ? earned + next : count ? pricing.message(count, config) : '';
      if (progress.textContent !== message) progress.textContent = message;
      progress.hidden = !message;
      const meter = this.querySelector('[data-savings-meter]');
      if (meter) {
        meter.max = offer.target;
        meter.value = offer.count;
        meter.setAttribute('aria-valuetext', message);
        const counter = this.querySelector('[data-savings-count]');
        if (counter) counter.textContent = `${offer.count} / ${offer.target}`;
        for (const milestone of this.querySelectorAll('[data-savings-milestone]')) {
          const isReward = milestone.classList.contains('ld-savings__milestone--free');
          if (isReward) {
            milestone.dataset.savingsMilestone = offer.target;
            milestone.querySelector('.ld-savings__milestone-count').textContent = config.items.replace('[count]', offer.target);
            milestone.lastElementChild.textContent = nextReward;
          } else {
            milestone.hidden = offer.free > 0;
          }
          milestone.toggleAttribute('data-reached', offer.count >= Number(milestone.dataset.savingsMilestone));
        }
      }
    }
  }
  customElements.define('ld-tiered-savings', TieredSavings);
  function setCart(cart) {
    if (!cart) return false;
    const count = Number.isFinite(Number(cart.item_count)) ? Number(cart.item_count)
      : Array.isArray(cart.items) ? cart.items.reduce((sum, item) => sum + pricing.quantity(item.quantity), 0) : null;
    if (count === null) return false;
    cartCount = pricing.quantity(count);
    for (const component of components) component.update(cartCount);
    return true;
  }
  let request = null;
  let refreshTimer;
  async function refreshCart() {
    if (request) return request;
    request = (async () => {
      try {
        const response = await fetch(config.cartUrl, {credentials: 'same-origin', cache: 'no-store'});
        if (response.ok) setCart(await response.json());
      } catch (_) { /* Keep server-rendered messaging when the network is unavailable. */ }
      finally { request = null; }
    })();
    return request;
  }
  function scheduleRefresh() {
    clearTimeout(refreshTimer);
    refreshTimer = setTimeout(refreshCart, 160);
  }
  for (const name of ['theme:cart:change', 'theme:cart:init', 'theme:cart:reload']) {
    document.addEventListener(name, event => {
      if (!setCart(event.detail?.cart)) scheduleRefresh();
    });
  }
  window.addEventListener('pageshow', scheduleRefresh);

})();
